import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsTimeRepartitionReportComponent } from './fields-interventions-time-repartition-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';
import {TimePieChartModule} from '../../../../reports/charts/time-pie-chart/time-pie-chart.module';



@NgModule({
  declarations: [FieldsInterventionsTimeRepartitionReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule,
    TimePieChartModule
  ],
  exports: [FieldsInterventionsTimeRepartitionReportComponent]
})
export class FieldsInterventionsTimeRepartitionReportModule { }
